import React from 'react';
import range from 'lodash/range'
import PropTypes from 'prop-types';

const moreThanMaxSymbol = 'more';
const blankValue = 'blankValue';

const dropdownMaxValue = (maxDropdownItems, multipleOf, minQuantity) => (maxDropdownItems * multipleOf) + minQuantity

/*
 * BBS DDD 2017-12-23 Switches between a dropdown and number input if mobile.
 * otherwise just show number input.
 *
 * This is a little convoluted.
 */
class NumberInputSelect extends React.Component {
  constructor(props) {
    super(props);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    const multipleOf = props.multipleOf > 0 ? props.multipleOf : 1;
    this.state = {
        useInput: props.minQuantity < 1 || props.quantity > dropdownMaxValue(props.maxDropdownItems, multipleOf, props.minQuantity),
        quantity: props.quantity
    }
  }

  /*
   * When input changes, we receive the event from the input
   */
  onInputChange(e) {
    this.setState({ quantity: e.target.value });
  }

  /*
   * When the user moves away from the input, we receive the event from the input
   */
  onInputBlur(e) {
    const value = e.target.value;
    if (!isNaN(value)) {
      this.onQuantityChange(+value);
      return;
    }
  }

  /*
   * When we want to notify the outside world we've changed, call this.
   */
  onQuantityChange(val) {
      const number = +val;
      if (!isNaN(number) && this.props.quantity !== number) 
          this.props.onChange(number);
  }

  /*
   * When the select input changes, call this with the new value selected by the user
   */
  onSelectChange(val) {
    if (val === blankValue) {
      return;
    }

    if (val === moreThanMaxSymbol) {
      this.setState({ useInput: true });
      this.onQuantityChange(this.props.maxDropdownQuantity + 1);
    } else {
      this.onQuantityChange(val);
    }
  }

  render() {
    const isMoreThanMax = this.props.quantity > this.props.maxDropdownQuantity;
    const useInput = (isMoreThanMax || this.state.useInput);
    const minQuantity = this.props.minQuantity < 0 ? 0 : this.props.minQuantity;
    const multipleOf = this.props.multipleOf > 1 ? this.props.multipleOf : 1;
    const dropdownMaxVal = dropdownMaxValue(this.props.maxDropdownItems, multipleOf, minQuantity)
    return (
      <span className={this.props.componentClassName}>
        <input
            className={useInput ? 'd-inline-block' : 'd-none'}
            min={minQuantity}
            onInput={this.onInputChange}
            onChange={this.onInputChange}
            onBlur={this.onInputBlur}
            type="number"
            value={ this.state.quantity }
            style={{width: 100}}
        />
        <select
            className={useInput ? 'd-none' : 'd-inline-block'}
            onChange={(e) => this.onSelectChange(e.target.value)}
            value={ this.props.quantity }
        >

          {/* range is "up to not including max" so to show maxDropwdownQuantity in the
           select, add 1 to it to make end argument to range */}
          {range(minQuantity, dropdownMaxVal + 1, multipleOf) 
            .map(
              (n) => (
                <option
                    key={n}
                    value={n}
                >{n}</option>))}

          <option
              key={moreThanMaxSymbol}
              value={moreThanMaxSymbol}
          >More</option>

          <option
              key={blankValue}
              value={blankValue}
          />

          <option
              key={0}
              value='0'
          >0</option>

        </select >
        {this.props.onDelete &&
          <a
              className={'btn btn-secondary item-delete' + (this.state.useInput ? '' : ' d-none d-sm-inline')}
              href=""
              onClick={(e) => { e.preventDefault(); this.props.onDelete(); }}
              style={{ marginLeft: 15 }}
          >
            <span className="fa fa-trash" />
          </a>
        }

      </span>
    )
  }
}

NumberInputSelect.propTypes = {
  componentClassName: PropTypes.string,
  maxDropdownItems: PropTypes.number.isRequired,
  minQuantity: PropTypes.number,
  multipleOf: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired
}

export default NumberInputSelect


// WEBPACK FOOTER //
// ./src/Components/checkout/components/FormComponents/NumberInputSelect.jsx